import {
  EditContextProvider,
  Form,
  SaveButton,
  useEditController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import {
  Button as MUIButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Resources } from '../resource';
import BannerForm from './BannerForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const EditBanner = ({ id, onClose }: { id: string | number; onClose: () => void }) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useEditController({
    id,
    resource: Resources.banners,
    mutationMode: 'pessimistic',
    mutationOptions: {
      onSuccess: () => {
        notify(t('module.banners.updateSuccess'), { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        const errorCode = error?.body?.code || error?.code;
        switch (errorCode) {
          default:
            notify(t('module.banners.unknownErrorUpdate') || error?.message || 'Unknown error', {
              type: 'error',
            });
            break;
        }
      },
    },
  });

  if (controller.isLoading || !controller.record) return null;

  return (
    <EditContextProvider value={controller}>
      <Form disableInvalidFormNotification>
        <DialogTitle>{t('module.banners.edit')}</DialogTitle>
        <DialogContent>
          <BannerForm isCreate={false} />
        </DialogContent>
        <DialogActions>
          <MUIButton
            variant="outlined"
            onClick={() => {
              onClose();
            }}
          >
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="banners" action="update">
            <SaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </EditContextProvider>
  );
};

export default EditBanner;






